import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

const nephropaties = [
  'nephropathy_undefined',
  'nephropathy_diabetic',
  'nephroangiosclerose',
  'berger_disease',
  'hyalinosis',
  'glomerulonephritis',
  'polycystic_kidney_disease',
  'uropathies',
  'lupus',
  'vasculitis',
  'pyelonephritis'
];

export default <template>
  <div class='field'>
    <@form.Dropdown
      @labelName='Néphropathie'
      @propertyName='nephropatie'
      @allowAdditions={{true}}
      as |dropdown|
    >
      {{#each nephropaties as |key|}}
        <dropdown.Item @key={{key}} @value={{t 'nephropaties.name' key=key}} />
      {{/each}}
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
